import {
  RepeatIcon,
  TriangleUpIcon,
  MinusIcon,
  SunIcon,
  MoonIcon,
  ViewIcon,
  LockIcon,
} from "@chakra-ui/icons";
import {
  Button,
  Tag,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useColorMode,
  Flex,
  Heading,
  Spacer,
  useToast,
} from "@chakra-ui/react";
import { StatsForNerds } from "../../types/stats";
import { getHeadersForRequest } from "../../utils/stats";
import { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import { FaPause, FaPlay } from "react-icons/fa";

interface StatsHeaderProps {
  data: StatsForNerds | null;
  loading: boolean;
  paused: boolean;
  onRefresh: () => void;
  onTogglePause: () => void;
}

export function StatsHeader({
  data,
  loading,
  paused,
  onRefresh,
  onTogglePause,
}: StatsHeaderProps) {
  const { colorMode, toggleColorMode } = useColorMode();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const toast = useToast();

  const getThemeIcon = () => {
    switch (colorMode) {
      case "light":
        return <SunIcon />;
      case "dark":
        return <MoonIcon />;
      default:
        return <ViewIcon />;
    }
  };

  const handleLogout = async () => {
    setIsLoading(true);
    try {
      const headers = await getHeadersForRequest();
      const response = await axios.get(
        `${process.env.REACT_APP_TEST_API_URL}/auth/logout`,
        {
          headers,
        }
      );
      console.log(response.data);
      if (response.data.errorCode === 0) {
        setIsLoading(false);
        Cookies.remove("userName");
        Cookies.remove("userToken");
        Cookies.remove("emailAddress");
        Cookies.remove("deviceId");
        localStorage.clear();
        toast({ title: "Successfully Logged Out", status: "success" });
        navigate("/");
      } else {
        toast({ title: "Failed to logout", status: "error" });
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error logging out:", error);
      toast({ title: "Failed to logout", status: "error" });
      setIsLoading(false);
    }
  };

  return (
    <Flex
      as="header"
      direction={{ base: "column", sm: "row" }}
      alignItems={{ base: "start", sm: "center" }}
      gap={4}
      mb={6}
    >
      <Flex alignItems="center" gap={3}>
        <Heading as="h1" size="lg" fontFamily="mono">
          📊 Server Stats For Nerds
        </Heading>
        {data && (
          <Tag colorScheme="gray" fontFamily="mono" fontSize="xs">
            Last: {new Date(data.ts).toLocaleTimeString()}
          </Tag>
        )}
      </Flex>

      <Spacer />

      <Flex alignItems="center" gap={2}>
        <Button borderRadius={20}
          onClick={onRefresh}
          isLoading={loading}
          variant="outline"
          // size="sm"
          // leftIcon={}
        >
          <RepeatIcon />
        </Button>

        <Button borderRadius={20}
          onClick={onTogglePause}
          variant={paused ? "solid" : "outline"}
          // size="sm"
          // leftIcon={}
        >
          {paused ? <FaPlay /> : <FaPause/>}
        </Button>

        {/* <Menu>
          <MenuButton as={Button} variant="outline" size="sm">
            {getThemeIcon()}
          </MenuButton>
          <MenuList>
            <MenuItem onClick={() => toggleColorMode()}>
              <SunIcon mr={2} />
              Toggle Theme
            </MenuItem>
          </MenuList>
        </Menu> */}

        <Button borderRadius={20} onClick={toggleColorMode}>
          {colorMode === "light" ? <MoonIcon /> : <SunIcon />}
        </Button>

        <Button borderRadius={20}
          // onClick={handleLogout}
          onClick={() => navigate(-1)}
          colorScheme="red"
          // size="sm"
          isLoading={isLoading}
        >
          <FiLogOut />
        </Button>
      </Flex>
    </Flex>
  );
}
